/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  uploadWhatsappFileWitSession(inboxId, formData) {
    return axios.post(`${this.url}/${inboxId}/upload_whatsapp_file_whit_session`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  uploadWhatsappFileFromUrl(inboxId, url_file) {
    console.log('url_file', url_file);
    return axios.post(`${this.url}/${inboxId}/upload_whatsapp_file_from_url`, {url_file:url_file
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  saveTemplate(data){
    return axios.post(`${this.url}/${data.waba_id}/save_template`, data);
  }
  deleteTemplate(data){
    return axios.post(`${this.url}/${data.waba_id}/delete_template`, {template_name: data.template_name});
  }
}

export default new Inboxes();
